import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns, DashboardModule, ModuleBlankState, PageHeader,
} from '@campaignhub/suit-theme'

const Overview = (props) => {
  const { prop } = props

  return (
    <>
      <PageHeader
        actionContent={(
          <Button buttonStyle="primaryCreate" size="medium">
            Create
          </Button>
        )}
        activeTabBarItemKey="dashboard"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={[
          {
            href: '#/',
            icon: faHome,
            key: 'dashboard',
            title: 'Dashboard',
          },
        ]}
        title="Campaign Overview"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <DashboardModule
              headerRight={<DashboardModule.Link href="#/">Module Link</DashboardModule.Link>}
              title="Module"
            >
              <ModuleBlankState>
                <ModuleBlankState.Title>No Tasks to Display</ModuleBlankState.Title>

                <ModuleBlankState.Paragraph>
                  Tasks are created when you assign a workflow to a campaign. Workflow Tasks can be located in the
                  campaign menu.
                </ModuleBlankState.Paragraph>
              </ModuleBlankState>
            </DashboardModule>

            <DashboardModule
              headerRight={<DashboardModule.Link href="#/">Module Link</DashboardModule.Link>}
              title="Module"
            >
              <ModuleBlankState>
                <ModuleBlankState.Title>No Tasks to Display</ModuleBlankState.Title>

                <ModuleBlankState.Paragraph>
                  Tasks are created when you assign a workflow to a campaign. Workflow Tasks can be located in the
                  campaign menu.
                </ModuleBlankState.Paragraph>
              </ModuleBlankState>
            </DashboardModule>
          </Columns.Main>

          <Columns.Sidebar>
            <DashboardModule title="Actions">
              <Box flexDirection="column" padding="large">
                <Button buttonStyle="secondary" icon={<FontAwesomeIcon icon={faHome} />} onClick={null} size="medium">
                  Campaign Action
                </Button>
              </Box>
            </DashboardModule>
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

Overview.propTypes = {}

export default Overview
